import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "extranet_assets",
  "use": "extranet_assets-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"extranet_assets\"><g fill-rule=\"nonzero\"><path d=\"M0 11h16v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2zM0 1.008v8h16v-8a1 1 0 00-1-1H1a1 1 0 00-1 1zm14 3h-3v-2h3v2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id